import { connect } from 'react-redux';
import ZohoView from './ZohoView.jsx';
import { getIntegrationForType, fetchIntegrations } from 'src/legacy/redux/actions/integrations.jsx';
import { authenticateAccount } from 'src/legacy/redux/actions/integrations/zoho.jsx';
import _ from 'lodash';
import withUseHooks from 'src/legacy/components/withUseHooks.jsx';
import {trackAdoptionMetricsForPluginConnectedEvent} from "src/legacy/redux/actions/adoption";

const mapStateToProps = (state, ownProps) => {
  let integration = getIntegrationForType(state, 'zoho_v2');
  return {
    integration: integration,
    integrations: state.legacyRootReducer.settings.integrations,
    user: state.users.me,
    deactivating: state.legacyRootReducer.settings.integrations.activated.deactivating.loading,
    error: state.legacyRootReducer.settings.integrations.email.error,
    user: _.get(state, 'users.me',""),
    integrationsLoading: _.get(state.legacyRootReducer.settings.integrations, 'activated.loading' ,false)
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    authenticateAccount: (code, location) => {
      return dispatch(authenticateAccount(code, location));
    },

    fetchIntegrations: () => {
      return dispatch(fetchIntegrations());
    },
    trackAdoptionMetricsForPluginConnectedEvent: (partnerName) => {
      return dispatch(trackAdoptionMetricsForPluginConnectedEvent(partnerName))
    }
  }
}

const ZohoPage = connect (
    mapStateToProps,
    mapDispatchToProps
)(ZohoView);

export default withUseHooks(ZohoPage);
